import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})
export class HrCurrentFormKeys {
    formNameLabelMap: Map<string, string> = new Map<string, string>();

    constructor(private translateService: TranslateService) {}

    add(name: string, label: string) {
        this.formNameLabelMap.set(name, label);
    }

    clear() {
        this.formNameLabelMap.clear();
    }

    translateKey(formKey: string) {
        for (let item of this.formNameLabelMap.keys()) {
            if (item === formKey) {
                return this.translateService.instant(this.formNameLabelMap.get(item));
            }
        }
        return '';
    }
}
